"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var EventEmitter = require("eventemitter2").EventEmitter2;
var Promise = require("promise6");
var window = require("global");
var prop = require("prop");
var phonertcProp = prop("cordova.plugins.phonertc");
var document = window.document;
var localStorage = window.localStorage;

/**
 * @class  phonertc
 */

module.exports = {
	type: "phonertc",
	init: init,
	RTC: RTC,
	resetVideoView: resetVideoView
};

setupVideoView();

/**
 * This is the bare bones for an RTC adapter for use with Buzz
 * Events:
 * ice: Local ICE candidate available: {
 * 		type:"candidate",
 * 		candidate: "iceCandidate.candidate",
 * 		label:"iceCandidate.sdpMLineIndex",
 * 		"id":"iceCandidate.sdpMid"
 * 	}
 * sdp: Local SDP data: {type:"offer",sdp:"sdp.description"},
 * stream: Remote stream has been received
 * close: The connection has been closed
 * error: There was some sort of error
 *
 * @memberOf phonertc
 * @param options {Object} contains options for creating the call {
 * 		iceServers:"ice servers",
 * 		local:"video tag for local stream",
 * 		remote:"video tag for remote stream",
 * 		isInitiator: "boolean for whether the user is the caller or not"
 * 	}
 */
function RTC(options) {
	EventEmitter.call(this);

	this._disconnected = false;

	var phonertc = getPlugin();

	var ice = (options.iceServers || []).reduce(function(found, current){
		if(found) return found;
		if(current.url.indexOf("turn:") !== -1)
			return current;
		return null;
	}, null) || {};
	var self = this;

	var video_input = localStorage.video_input;
	var voiceOnly = (video_input === "false") || options.voiceOnly;

	if (!voiceOnly)
		resetVideoView();

	window.addEventListener("orientationchange", resetVideoView);

	console.log("phonertc: Initiating session", options.isInitiator);
	var session = new phonertc.Session({
		isInitiator: options.isInitiator,
		turn: {
			host: ice.url,
			username: ice.username,
			password: ice.credential
		},
		streams: {
			audio: true,
			video: !voiceOnly
		}
	});

	this._session = session;

	session.on("sendMessage", function (data) {
		if (data.type == "candidate") {
			self.emit("ice", data);
		}
		if ((data.type == "offer") || (data.type == "answer")) {
			self.emit("sdp", data);
		}
	});

	session.on("disconnect", function () {
		self._disconnected = true;
		self.clean();
	});

	session.on("answer", function () {
		self.emit("stream", {
			local: {
				phonertc: true
			},
			remote: {
				phonertc: true
			}
		});
	});

	session.call();
}

function resetVideoView() {
	var phonertc = getPlugin();

	var remoteElement = document.getElementById("ae_remote_video");
	var localElement = document.getElementById("ae_local_video");

	console.log("phonertc: Resetting video view");

	if(!remoteElement) {
		console.log("phonertc: Remote video element not found");
		remoteElement = document.body;
		var fakeDimensions = [4,4];

		phonertc.setVideoView({
			containerParams: {
				position: fakeDimensions,
				size: fakeDimensions
			},
			local: {
				position: fakeDimensions,
				size: fakeDimensions
			},
			camera: localStorage.video_input
		});
	} else {
		console.log("phonertc: Remote video element found, calculating local position");
		var remote = remoteElement.getBoundingClientRect();

		var remotePosition = [remote.left, remote.top];
		var remoteSize = [remote.width, remote.height];


		var params = {
			camera: localStorage.video_input,
			containerParams: {
				position: remotePosition,
				size: remoteSize
			},
		};

		if(localElement){
			var local = localElement.getBoundingClientRect();
			var positionDeltaX = local.left - remote.left;
			var positionDeltaY = local.top - remote.top;
			var localPosition = [positionDeltaX, positionDeltaY];
			var localSize = [local.width, local.height];

			params.local = {
				position: localPosition,
				size: localSize
			};
		} else {
			params.local = {
				position: [2,2],
				size: [2,2]
			};
		}

		phonertc.setVideoView(params);
	}

	reset_orientation();
}

function reset_orientation() {
	try {
		var remoteElement = document.getElementById("ae_remote_video");
		if(!remoteElement) return;
		console.log("phonertc: orientation change detected, resetting orientation");
		if (is_horizontal())
			remoteElement.classList.add("ae-video-horizontal");
		else remoteElement.classList.remove("ae-video-horizontal");
	} catch(e){
		console.debug(e);
	}
}

function is_horizontal() {
	return window.innerHeight < window.innerWidth;
}

RTC.prototype = new EventEmitter();

/**
 * Add remote ICE candidates
 *
 * @memberOf phonertc
 * @param {String} ice The ice data that was received from the remote user
 * @return {Promise}   Resolves if adding the candidate was successful
 */
RTC.prototype.addICE = function (ice) {
	if (!ice) return;
	console.log("receive ice: ", JSON.stringify(ice));
	this._session.receiveMessage(ice);
	return Promise.resolve();
};

/**
 * Set the remote SDP
 *
 * @memberOf phonertc
 * @param {String} sdp SDP data that was received from the remote user
 * @return {Promise} Resolves if adding the SDP worked, rejects if it didn't
 */
RTC.prototype.addSDP = function (sdp) {
	if (!sdp) return;
	console.log("receive sdp", JSON.stringify(sdp));
	this._session.receiveMessage(sdp);
	return Promise.resolve();
};

/**
 * Function that takes the local SDP string and returns a modifed SDP string before the `sdp` event occures
 *
 * @memberOf phonertc
 * @param {String} sdp The local SDP string
 */
RTC.prototype.filterSDP = function (sdp) {
	// TODO: call this at some point
	return sdp;
};

/**
 * Cleans up any resources to destroy this object
 *
 * @memberOf phonertc
 * @return {Promise} Resolves after cleaning is finished
 */
RTC.prototype.clean = function () {
	if (!this._disconnected) {
		return new Promise(function (resolve) {
			window.removeEventListener("orientationchange", resetVideoView);
			this._session.on("disconnect", resolve);
			this._session.close();
			this._disconnected = true;
			var phonertc = getPlugin();
			try {
				phonertc.setVideoView();
			} catch (e) {
				// Oh well
			}
			phonertc.hideVideoView();
			this.emit("close");
		}.bind(this));
	} else {
		return Promise.resolve();
	}
};

/**
 * Handle all cleaning here
 *
 * @memberOf phonertc
 * @param  {Object} options Options are the options passed to an instance of RTC, declared at the top
 * @return {Promise}        Resolves to instance of RTC object
 */
function init(options) {
	options = options || {};
	return Promise.resolve(new RTC(options));
}

function getPlugin() {
	return phonertcProp(window);
}

function setupVideoView() {
	var phonertc = getPlugin();
	if(!phonertc) return;
	resetVideoView();
	phonertc.hideVideoView();
}
